import React, { useEffect, useState } from "react";
import { Container, Row, Modal, ModalBody, ModalHeader, Col } from "reactstrap";
import "../styles/contact.css";
import "../index.css";
import "../styles/header.css";
import { useDispatch, useSelector } from "react-redux";
import "../styles/payment-method.css";
import { toggleBookingModal, updateBookingDetails } from "../Features/authSlice";
import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";
import { constants } from "../Utils/constants";
// import carData from "../assets/data/carData";

function BookingModal(props) {
  const dispatch = useDispatch();
  const bookingModal = useSelector((state) => state.auth.bookingModal);
  const bookingDetail = useSelector((state) => state.auth.bookingDetail);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [flag, setFlag] = useState(true);

  useEffect(() => {}, [bookingDetail]);

  const doCancel = async () => {
    const resp = await axiosInstance.post(constants.serverUrl+`/booking/cancelBooking`, {
      bookingId: bookingDetail.id,
      description: "Cancel car booking for some reason.",
    });

    if (resp.data) {
      toast.success("Booking Cancelled Successfully !!!");

      dispatch(updateBookingDetails("CANCELLED"));
      dispatch(toggleBookingModal());
      setFlag(false);
    } else {
      toast.error("Something went wrong, please try again !!!");
    }
  };

  useEffect(() => {}, [props.cardData]);

  return (
    <Container>
      <Modal isOpen={bookingModal} backdrop="static">
        <ModalHeader
          className="border-0 d-flex justify-content-center"
          toggle={() => {
            dispatch(toggleBookingModal());
          }}
        >
          <h3>
            <strong>Booking Details</strong>
          </h3>
        </ModalHeader>
        <ModalBody>
          <Container>
            <Row>
              {/* bookingDate: "2023-08-24T20:06:54.815447"
                  branchCity: "pune"
                  branchLocality: "hinjewadi"
                  carBrand: "Lamborghini"
                  carModel: "Huracan"
                  fromDate: "2023-08-24T13:05:09.858"
                  id: 12
                  penalty: 0
                  returnDate: null
                  status: "SCHEDULED"
                  toDate: "2023-08-24T13:05:09.858"
                  tripCost: 5000 */}
              <Col className="mx-2">
                <Row className="mb-1 payment ">
                  <Col className="text-end">
                    <label className="fs-75">Booking Id :</label>
                  </Col>
                  <Col>
                    <label className=" fs-75">{bookingDetail.id}</label> 
                  </Col>
                </Row>
                <Row className="mb-1 payment">
                  <Col className="text-end">
                    <label className="fs-75">User Id :</label>
                  </Col>
                  <Col>
                    <label className=" fs-75">{currentUser.id}</label>
                  </Col>
                </Row>
                <Row className="mb-1 payment">
                  <Col className="text-end">
                    <label className=" fs-75">Car Brand :</label>
                  </Col>
                  <Col>
                    <label className=" fs-75">
                      {bookingDetail?.carBrand} {bookingDetail?.carModel}
                    </label>
                  </Col>
                </Row>
                <Row className="mb-1 payment">
                  <Col className="text-end">
                    <label className=" fs-75">Booking Date :</label>
                  </Col>
                  <Col>
                    <label className=" fs-75">
                      {new Date(
                        bookingDetail?.bookingDate
                      ).toLocaleDateString()}
                    </label>
                  </Col>
                </Row>
                <Row className="mb-1 payment">
                  <Col className="text-end">
                    <label className=" fs-75">From-Date :</label>
                  </Col>
                  <Col>
                    <label className=" fs-75">
                      {new Date(bookingDetail?.fromDate).toLocaleString()}
                    </label>
                  </Col>
                </Row>
                <Row className="mb-1 payment">
                  <Col className="text-end">
                    <label className=" fs-75">To-Date :</label>
                  </Col>
                  <Col>
                    <label className=" fs-75">
                      {new Date(bookingDetail?.toDate).toLocaleString()}
                    </label>
                  </Col>
                </Row>
                <Row className="mb-1 payment">
                  <Col className="text-end">
                    <label className=" fs-75">Trip Cost :</label>
                  </Col>
                  <Col>
                    <label className=" fs-75">
                      ₹ {bookingDetail?.tripCost}.00
                    </label>
                  </Col>
                </Row>
                <Row className="mb-1 payment">
                  <Col className="text-end">
                    <label className=" fs-75">Penalty :</label>
                  </Col>
                  <Col>
                    <label className=" fs-75">
                      ₹ {bookingDetail?.penalty}.00
                    </label>
                  </Col>
                </Row>
                <Row className="mb-1 payment">
                  <Col className="text-end">
                    <label className=" fs-75">Status :</label>
                  </Col>
                  <Col>
                    <label className=" fs-75">{bookingDetail?.status}</label>
                  </Col>
                </Row>
                <Row className="mb-1 mt-3 payment">
                  {flag && bookingDetail?.status === "SCHEDULED" && (
                    <button
                      className="btn-sm"
                      onClick={() => {
                        doCancel();
                        // dispatch(updateBookingDetails("COMPLETED"));

                        dispatch(toggleBookingModal());
                      }}
                    >
                      Cancel
                    </button>
                  )}
                </Row>
              </Col>
              {/* <Row className="mb-3 payment">
                  <label className=" fs-75">{bookingDetail.id}</label>
                </Row> */}
              {/* <Row className="mb-3 payment">
                  <label className=" fs-75">{currentUser.id}</label>
                </Row> */}
              {/* <Row className="mb-3 payment">
                  <label className=" fs-75">
                    {bookingDetail.carBrand} {bookingDetail.carModel}
                  </label>
                </Row> */}
              {/* <Row className="mb-3 payment">
                  <label className=" fs-75">{bookingDetail.bookingDate}</label>
                </Row> */}
              {/* <Row className="mb-3 payment">
                  <label className=" fs-75">{bookingDetail.fromDate}</label>
                </Row> */}
              {/* <Row className="mb-3 payment">
                  <label className=" fs-75">{bookingDetail.toDate}</label>
                </Row> */}
              {/* <Row className="mb-3 payment">
                  <label className=" fs-75">
                    ₹ {bookingDetail.tripCost}.00
                  </label>
                </Row> */}
              {/* <Row className="mb-3 payment">
                  <label className=" fs-75">₹ {bookingDetail.penalty}.00</label>
                </Row> */}
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </Container>
  );
}

export default BookingModal;
